import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'blockUi' })
class BlockUi extends VuexModule {
  active: boolean = false

  @Mutation
  setActive(active: boolean) {
    this.active = active
  }

  @Action
  SET_ACTIVE(active: boolean) {
    this.context.commit('setActive', active)
    if (active) {
      document.body.style.cursor = 'wait';
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.style.cursor = 'auto';
      document.body.classList.remove('overflow-hidden')
    }
  }
}

export default BlockUi
